import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { StateCustomPanelVehicleService } from '../../service/state-custom-panel-vehicle.service';
import { MapService } from 'src/app/vehicles/services/map.service';
import { Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  takeUntil,
} from 'rxjs/operators';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { TranslateService } from '@ngx-translate/core';
import { VehicleConfigService } from 'src/app/vehicles/services/vehicle-config.service';
@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit, OnDestroy {
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  @Output() eventDisplayGroup = new EventEmitter<boolean>();
  @Output() eventKeyUpToFilter = new EventEmitter<{
    value: string;
    isEmpty: boolean;
  }>();
  public isSelectedInputSearch = false;
  public stateOptions: { label: string; value: number }[] = []

  public items = [
    { idItem: 'verImei', variant: 'imei', type: 'IMEI' },
    { idItem: 'verColor', variant: 'color', type: 'COLOR' },
    { idItem: 'verIgnition', variant: 'ignition', type: 'IGNITION' },
    { idItem: 'verSpeed', variant: 'speed', type: 'SPEED' },
    {
      idItem: 'verBatteryVoltage',
      variant: 'batteryVoltage',
      type: 'BATTERY_VOLTAGE',
    },
    { idItem: 'verAmountOfFuel', variant: 'amountOfFuel', type: 'FUEL' },
    { idItem: 'verTimeElapsed', variant: 'timeElapsed', type: 'TIME_ELAPSED' },
    { idItem: 'verSatellite', variant: 'satellite', type: 'SATELLITE' },
    { idItem: 'verIconVehicle', variant: 'icon', type: 'ICON' },
    { idItem: 'ver', variant: 'see', type: 'SEE' },
    {
      idItem: 'verTransmissionStatus',
      variant: 'transmissionStatus',
      type: 'TRANSMISSION_STATUS',
    },
    { idItem: 'verDriver', variant: 'driver', type: 'DRIVER' },
    { idItem: 'verNameButton', variant: 'nameButton', type: 'NAME_BUTTON' },
    {
      idItem: 'verFollowUnitButton',
      variant: 'followUnitButton',
      type: 'FOLLOW_UNIT_BUTTON',
    },
    { idItem: 'verEye', variant: 'eye', type: 'EYE' },
  ];

  public valueSelectButton = 1;
  public showVehicleButtonOptions = true;
  public allOptionPanelHidden = false;
  private servicePanel: StateCustomPanelVehicleService;
  private mapService: MapService;
  private onDestroy$ = new Subject<boolean>();
  private searchSubject$ = new Subject<string>();

  constructor(
    _serviceCustomPanelVehicle: StateCustomPanelVehicleService,
    _mapService: MapService,
    private vehicleService: VehicleService,
    private translateService: TranslateService,
    public vehicleConfigService : VehicleConfigService
  ) {
    this.servicePanel = _serviceCustomPanelVehicle;
    this.mapService = _mapService;
    this.stateOptions = this.vehicleConfigService.stateOptionsButtons;
    let configVehicleButton = this.vehicleConfigService.valueSelectButtonSubject.getValue()
    this.valueSelectButton = configVehicleButton.selected
    this.showVehicleButtonOptions = configVehicleButton.showOptions
    this.allOptionPanelHidden = this.servicePanel.allHidden;
  }

  ngOnInit() {
    this.setupSearchSubscription();
    this.setLastValueInButton();
  }

  private setupSearchSubscription(): void {
    this.searchSubject$
      .pipe(
        takeUntil(this.onDestroy$),
        debounceTime(300),
        distinctUntilChanged(),
        map((value: string) => value.trim()),
        map((value: string) => ({
          value,
          isEmpty: value.length === 0,
        }))
      )
      .subscribe({
        next: (searchData) => {
          this.isSelectedInputSearch = !searchData.isEmpty;
          this.eventKeyUpToFilter.emit(searchData);
        },
        error: (error) => {
          console.error('Error en el stream de búsqueda:', error);
        },
      });
  }

  onSearchInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchSubject$.next(value);
  }

  onClickClearInput(input: HTMLInputElement) {
    input.value = '';
    this.searchSubject$.next('');
  }

  setLastValueInButton() {
    if (this.servicePanel.getShowNameButton()) {
      this.valueSelectButton = 1;
    }
    if (this.servicePanel.getShowInternalCodeItemButton()) {
      this.valueSelectButton = 2;
    }
    if (this.servicePanel.getShowNamePlateItemButton()) {
      this.valueSelectButton = 3;
    }
  }

  onClickSelectButton() {
    switch (this.valueSelectButton) {
      case 1: {
        this.servicePanel.setShowNameItemButton(true);
        this.mapService.changeNameVehicles('Nombre');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.name_old;
            return vehicle;
          }
        );
        break;
      }
      case 2: {
        this.servicePanel.setShowInternalCodeItemButton(true);
        this.mapService.changeNameVehicles('cod_interno');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.cod_interno!;
            return vehicle;
          }
        );
        break;
      }
      case 3: {
        this.servicePanel.setShowNamePlateItemButton(true);
        this.mapService.changeNameVehicles('num_plate');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.plate_number!;
            return vehicle;
          }
        );
        break;
      }
      default: {
        console.log('Revisar los value que brindaste en options');
      }
    }
  }

  onClickGroup() {
    this.eventDisplayGroup.emit(true);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }
}
